import { cn } from '@/lib/cn';
import type { HTMLAttributes } from 'react';

export interface SectionProps extends HTMLAttributes<HTMLDivElement> {
  containerClassName?: string;
}

export const Section = ({
  id,
  containerClassName,
  className,
  ...props
}: SectionProps) => {
  return (
    <section
      id={id}
      className={cn(
        'px-4 py-12.5 lg:px-6 lg:pt-22.5 lg:pb-25',
        containerClassName,
      )}
    >
      <div
        className={cn('mx-auto w-full max-w-305', className)}
        {...props}
      ></div>
    </section>
  );
};
